import React, { FC } from "react";

import { MonthFormat } from "@/components/atoms";

import { StyledPaymentBlock } from "./styled";

export type PaymentItemProps = {
    key: string;
    amount: string;
    date?: Date;
    index: number;
    bankAccount?: string;
    beneficiary?: string;
};
const PaymentItem: FC<PaymentItemProps> = ({ amount, date, beneficiary, bankAccount, index }) => {
    return (
        <StyledPaymentBlock $withBorderBottom={index !== 0} className="flex1">
            {date && (
                <div className="vertical-date">
                    <span className="date">{date.getDate()}</span>
                    <span className="month">
                        <MonthFormat month={date.getMonth()} />
                    </span>
                    <span className="year">{date.getFullYear()}</span>
                </div>
            )}
            <div className="beneficiary-block">
                <span className="beneficiary">{beneficiary}</span>
                <span className="bank-account">{bankAccount}</span>
            </div>
            <div className="amount">{amount}</div>
        </StyledPaymentBlock>
    );
};

export default PaymentItem;
